import { render, staticRenderFns } from "./prePublishWidge.vue?vue&type=template&id=496f034b&scoped=true"
import script from "./prePublishWidge.vue?vue&type=script&lang=js"
export * from "./prePublishWidge.vue?vue&type=script&lang=js"
import style0 from "./prePublishWidge.vue?vue&type=style&index=0&id=496f034b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496f034b",
  null
  
)

export default component.exports